export const ANALYTICS_PUSH = 'ANALYTICS_PUSH';
export const GEO_CHECK = 'GEO_CHECK';
export const COOKIE_CONFIG = 'COOKIE_CONFIG';
export const VIDEOLAND_LOGIN = 'VIDEOLAND_LOGIN';
export const ACCOUNT_RESET_PASSWORD = 'ACCOUNT_RESET_PASSWORD';
export const ACCOUNT_CHECK_RESET_TOKEN = 'ACCOUNT_CHECK_RESET_TOKEN';
export const ACCOUNT_UPDATE_PASSWORD = 'ACCOUNT_UPDATE_PASSWORD';
export const OVERWRITE_UID = 'OVERWRITE_UID';
export const OVERWRITE_REDIRECT_URL = 'OVERWRITE_REDIRECT_URL';
export const CLEAR_REDIRECT_URL = 'CLEAR_REDIRECT_URL';
export const DEFER_LOGIN = 'DEFER_LOGIN';
export const DEFER_LOGIN_RESET = 'DEFER_LOGIN_RESET';
export const GIGYA_CLOSE_POPUP = 'GIGYA_CLOSE_POPUP';
export const GIGYA_INIT_REGISTRATION = 'GIGYA_INIT_REGISTRATION';
export const GIGYA_REGISTER = 'GIGYA_REGISTER';
export const GIGYA_GET_ACCOUNT_INFO = 'GIGYA_GET_ACCOUNT_INFO';
export const GIGYA_SET_ACCOUNT_INFO = 'GIGYA_SET_ACCOUNT_INFO';
export const GIGYA_LOGIN = 'GIGYA_LOGIN';
export const GIGYA_VERIFY_LOGIN = 'GIGYA_VERIFY_LOGIN';
export const GIGYA_LOGOUT = 'GIGYA_LOGOUT';
export const GIGYA_LINK_ACCOUNT = 'GIGYA_LINK_ACCOUNT';
export const IDENTITY_SERVICE_LOGOUT = 'IDENTITY_SERVICE_LOGOUT';
export const RESEND_VERIFICATION_CODE = 'RESEND_VERIFICATION_CODE';
export const GIGYA_FINALIZE_REGISTRATION = 'GIGYA_FINALIZE_REGISTRATION';
export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE'; // Due to https://github.com/erikras/redux-form/issues/3973
export const HELP_OPEN = 'HELP_OPEN';
export const HELP_CLOSE = 'HELP_CLOSE';
export const ACCOUNT_CLEAR = 'ACCOUNT_CLEAR';
export const NOTIFICATION_SHOW = 'NOTIFICATION_SHOW';
export const NOTIFICATION_HIDE = 'NOTIFICATION_HIDE';
